<template>
  <station-list-table />
</template>

<script>
import StationListTable from "../../components/station/StationListTable";
export default {
  name: "ProbeList",
  components: {
    'station-list-table': StationListTable
  },
}
</script>

<style scoped>

</style>